import { useLanguage } from '../../../contexts/LanguageContext';
import { LinkedText } from '../../../components/LinkedText';
import RegisterLink from '../../../components/RegisterLink';
import heroMyrMalaysiaFlag from '../../../assets/hero-myr-malaysia-flag.png';
import gamesCategorySlot from '../../../assets/games-category-slot.png';
import gamesCategoryLiveCasino from '../../../assets/games-category-live-casino.png';
import gamesCategoryFishing from '../../../assets/games-category-fishing.png';

export default function GamesSection() {
  const { t } = useLanguage();

  const games = [
    {
      img: gamesCategorySlot,
      alt: 'Slot Games Malaysia',
      en_title: 'Pokies & Slots',
      bm_title: 'Pokies & Slot',
      en_desc: "Hundreds of exciting pokies with high RTP rates, progressive jackpots and immersive themes. From classic 3-reels to cutting-edge video slots.",
      bm_desc: "Ratusan pokies menarik dengan kadar RTP tinggi, jackpot progresif sehingga RM4.7 juta, dan tema yang imersif. Dari 3-reel klasik hingga slot video terkini.",
      en_cta: 'Play Slots',
      bm_cta: 'Main Slot',
      source: 'games_section_slots',
      gradient: 'from-[#cc1100] to-[#880000]',
    },
    {
      img: gamesCategoryLiveCasino,
      alt: 'Live Casino Malaysia',
      en_title: 'Live Casino',
      bm_title: 'Kasino Langsung',
      en_desc: 'Experience real-time gaming with professional dealers, HD streaming, and authentic atmosphere. Baccarat, Roulette, Blackjack available 24/7.',
      bm_desc: 'Nikmati permainan masa nyata dengan peniaga profesional, penstriman HD, dan suasana autentik. Baccarat, Roulette, Blackjack tersedia 24/7.',
      en_cta: 'Play Live',
      bm_cta: 'Main Langsung',
      source: 'games_section_live_casino',
      gradient: 'from-[#d4a017] to-[#a87c10]',
    },
    {
      img: gamesCategoryFishing,
      alt: 'Fishing arcade games Malaysia',
      en_title: 'Fishing',
      bm_title: 'Permainan Memancing',
      en_desc: 'Fast-paced fishing and shoot-to-catch arcade titles with big multipliers, vivid underwater scenes, and payouts straight to your wallet.',
      bm_desc: 'Permainan arked memancing dan tembak ikan yang pantas dengan pembesar ganjaran tinggi, suasana bawah air menarik, dan bayaran terus ke dompet anda.',
      en_cta: 'Play Fishing',
      bm_cta: 'Main Memancing',
      source: 'games_section_fishing',
      gradient: 'from-[#cc1100] to-[#d4a017]',
    },
  ];

  return (
    <section
      id="explore-game-categories"
      style={{ background: 'linear-gradient(180deg, #080000 0%, #0d0101 100%)' }}
      className="py-16 md:py-24"
    >
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        {/* Header */}
        <div className="text-center mb-10 md:mb-14">
          <div className="inline-flex items-center gap-2 bg-[#cc1100]/15 border border-[#cc1100]/30 rounded-full px-4 py-1.5 mb-4">
            <span className="w-3 h-3 flex items-center justify-center">
              <i className="ri-gamepad-line text-[#d4a017] text-xs" />
            </span>
            <span className="text-[#d4a017] text-xs font-semibold tracking-widest uppercase">
              {t('Game Library', 'Perpustakaan Permainan')}
            </span>
          </div>
          <h2 className="text-3xl md:text-4xl font-black text-white mb-4">
            {t('Explore Our', 'Terokai')}{' '}
            <span
              className="text-transparent bg-clip-text"
              style={{ backgroundImage: 'linear-gradient(135deg, #cc1100, #d4a017)' }}
            >
              {t('Game Categories', 'Kategori Permainan')}
            </span>
          </h2>
          <p className="text-gray-400 max-w-2xl mx-auto text-sm leading-relaxed">
            {t(
              'From classic pokies to live dealer tables and fishing arcade hits, MrCuci offers 5,000+ games. All winnings paid in Ringgit with instant withdrawal.',
              'Dari pokies klasik hingga meja peniaga langsung dan permainan memancing arked, MrCuci menawarkan 5,000+ permainan. Semua kemenangan dibayar dalam Ringgit dengan pengeluaran segera.'
            )}
          </p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {games.map((game) => (
            <div
              key={game.en_title}
              className="rounded-2xl overflow-hidden hover:scale-[1.02] transition-all duration-300 group"
              style={{ background: 'linear-gradient(135deg, #180303, #1e0404)', border: '1px solid rgba(204,17,0,0.2)' }}
            >
              <div className="relative w-full h-48 md:h-52 overflow-hidden">
                <img
                  src={game.img}
                  alt={game.alt}
                  className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-[#0d0000]/80 to-transparent" />

                {/* MYR tag */}
                <div className="absolute bottom-3 left-3 flex items-center gap-1.5 bg-black/60 rounded-full px-2 py-1">
                  <img
                    src={heroMyrMalaysiaFlag}
                    alt=""
                    className="h-4 w-auto max-w-[1.35rem] shrink-0 rounded-sm object-contain"
                  />
                  <span className="text-[#d4a017] text-xs font-semibold">RM</span>
                </div>
              </div>
              <div className="p-4 md:p-5">
                <h3 className="text-white font-black text-lg md:text-xl mb-2">{t(game.en_title, game.bm_title)}</h3>
                <p className="text-gray-500 text-xs md:text-sm leading-relaxed mb-4"><LinkedText>{t(game.en_desc, game.bm_desc)}</LinkedText></p>
                <RegisterLink
                  source={game.source}
                  label={t(game.en_cta, game.bm_cta)}
                  className="inline-flex items-center gap-2 font-bold text-sm px-5 py-2.5 rounded-lg hover:opacity-90 transition-all whitespace-nowrap cursor-pointer text-black"
                  style={{ background: 'linear-gradient(135deg, #cc1100, #d4a017)' }}
                >
                  <span>{t(game.en_cta, game.bm_cta)}</span>
                  <span className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-arrow-right-line" />
                  </span>
                </RegisterLink>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
